import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { MaintenanceContractsRoutes } from '../../../routes';

export const MaintenanceContractsLayout = () => <SwitchRoute routes={MaintenanceContractsRoutes} />;
